import { cn } from '@/shared/lib/cn';

type AmountVariant = 'debt' | 'paid' | 'credit' | 'muted' | 'gradient' | 'neutral';

interface MonoAmountProps {
  value: string;
  variant?: AmountVariant;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const variantClasses: Record<AmountVariant, string> = {
  debt: 'text-status-debt',
  paid: 'text-status-paid',
  credit: 'text-status-credit',
  muted: 'text-text-muted',
  gradient: 'text-brand-gradient',
  neutral: 'text-text-primary',
};

const sizeClasses: Record<string, string> = {
  sm: 'text-sm',
  md: 'text-lg font-semibold',
  lg: 'text-[22px] font-bold',
  xl: 'text-[38px] font-bold leading-tight',
};

export function MonoAmount({ value, variant = 'neutral', size = 'md', className }: MonoAmountProps) {
  return (
    <span
      className={cn(
        'font-mono font-tabular',
        variantClasses[variant],
        sizeClasses[size],
        className,
      )}
    >
      {value}
    </span>
  );
}
